import React from "react";
import { Badge } from "../../../../ui/components/Badge";
import { InvoiceEntity, InvoiceListStatus } from "../../domain";
import {
  getInvoiceListStatus,
  getInvoiceListStatusLabel,
} from "../utils/invoiceListStatus";

interface InvoiceStatusChipProps {
  invoice?: InvoiceEntity;
  status?: InvoiceListStatus;
}

export const InvoiceStatusChip: React.FC<InvoiceStatusChipProps> = ({
  invoice,
  status,
}) => {
  const resolvedStatus = status ?? (invoice ? getInvoiceListStatus(invoice) : "all");

  switch (resolvedStatus) {
    case "posted":
      return <Badge variant="success">{getInvoiceListStatusLabel(resolvedStatus)}</Badge>;
    case "under_review":
      return <Badge variant="warning">{getInvoiceListStatusLabel(resolvedStatus)}</Badge>;
    case "duplicate":
    case "rejected":
      return <Badge variant="error">{getInvoiceListStatusLabel(resolvedStatus)}</Badge>;
    case "on_hold":
      return <Badge variant="neutral">{getInvoiceListStatusLabel(resolvedStatus)}</Badge>;
    case "pending":
    default:
      return <Badge variant="neutral">{getInvoiceListStatusLabel(resolvedStatus)}</Badge>;
  }
};
